import { isNative } from "@/lib/capacitor"
import { registerDeviceToken, unregisterDeviceToken } from "@/services/push-notification-service"
import { toast } from "sonner"

let currentToken: string | null = null

export async function initPushNotifications() {
  if (!isNative) return

  const { PushNotifications } = await import("@capacitor/push-notifications")

  const permResult = await PushNotifications.requestPermissions()
  if (permResult.receive !== "granted") return

  await PushNotifications.register()

  PushNotifications.addListener("registration", async token => {
    currentToken = token.value
    try {
      await registerDeviceToken(token.value)
    } catch (error) {
      console.error("Failed to register device token:", error)
    }
  })

  PushNotifications.addListener("registrationError", error => {
    console.error("Push registration error:", error)
  })

  PushNotifications.addListener("pushNotificationReceived", notification => {
    toast(notification.title ?? "Nova notificação", {
      description: notification.body,
    })
  })

  PushNotifications.addListener("pushNotificationActionPerformed", action => {
    const data = action.notification.data
    if (data?.type?.startsWith("appointment.")) {
      window.dispatchEvent(
        new CustomEvent("push:navigate", {
          detail: { path: "/calendar" },
        })
      )
    }
  })
}

export async function teardownPushNotifications() {
  if (!isNative || !currentToken) return

  try {
    await unregisterDeviceToken(currentToken)
    const { PushNotifications } = await import("@capacitor/push-notifications")
    await PushNotifications.removeAllListeners()
    currentToken = null
  } catch (error) {
    console.error("Failed to teardown push notifications:", error)
  }
}
